import { Col, Input, Label, Tooltip } from "reactstrap";
import { useState } from "react";
import { TooltipLabelText } from "../../../../../../Constants/Constants";
import { TypesOfProductData } from "../../../../../../Data/Applications/ECommerce/ECommerce";
import { LI, UL } from "../../../../../../AbstractElements";

const TypesOfProduct = () => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <Col xs="12">
      <Label for="exampleFormControlInput1">{TooltipLabelText}
        <i className="icon-help-alt ms-1" id="tooltip1" />
        <Tooltip target="tooltip1" placement="top" toggle={toggle} isOpen={tooltipOpen}>{"Choose the kind of discount that will be used on that particular item."}</Tooltip>
      </Label>
      <UL className="radio-wrapper simple-list flex-row">
        {TypesOfProductData.map((data, i) => (
          <LI key={i}>
            <Input id={data.id} type="radio" name="radio5" defaultValue="option5" />
            <Label for={data.id} check><span>{data.title}</span></Label>
          </LI>
        ))}
      </UL>
    </Col>
  );
};

export default TypesOfProduct;